import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1872 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M545.554 163.178a391.257 391.257 0 1 0 800.752 0 391.257 391.257 0 1 0-800.752 0ZM1632.587 1250.23c-.876-379.278-307.96-686.474-686.657-686.474-378.7 0-685.784 307.196-686.66 686.474h1373.317z" /></svg>

const User = React.forwardRef((props, ref) => {
  return (
    <IconBase name="user" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

User.displayName = 'IconUser'

export default User
